"use client";

import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
          <div className="h-9 w-20 bg-white/20 animate-pulse rounded-md" />
          <div className="h-9 w-20 bg-white/20 animate-pulse rounded-md" />
          <div className="h-9 w-20 bg-white/20 animate-pulse rounded-md" />
          <div className="h-9 w-20 bg-white/20 animate-pulse rounded-md" />
          <div className="h-9 w-20 bg-white/20 animate-pulse rounded-md" />
        </div>;
  }
  return <>
        {}
        <NavigationMenu viewport={false} className="hidden md:flex">
          <NavigationMenuList>
            {menuItems.map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
                <NavigationMenuLink asChild className="bg-secondary hover:bg-secondary-hover focus:bg-secondary-active relative group px-5 py-2 text-sm font-medium text-white transition-all duration-[var(--duration-medium)] rounded-sm">
                  <Link to={item.href || "#"}>
                    {item.label}
                    <span className="absolute bottom-0 left-1/2 h-[2px] w-0 bg-primary transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:w-full group-hover:left-0" />
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>

        {}
        <Button variant="ghost" size="icon" className="md:hidden hover:bg-white/10 hover:text-primary transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
          {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </Button>

        {}
        {mobileMenuOpen && <div className="absolute top-full left-0 right-0 glass-effect border-t border-white/20 md:hidden">
            <nav className="container mx-auto px-6 py-4">
              <ul className="flex flex-col gap-2">
                {menuItems.map(item => <li key={item.id} data-index={item.id}>
                    <Link to={item.href || "#"} className="block px-5 py-3 text-sm font-medium text-white bg-secondary hover:bg-secondary-hover transition-all duration-[var(--duration-medium)] rounded-sm" onClick={() => setMobileMenuOpen(false)}>
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>}
      </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 z-50 w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-16 glass-effect border-b border-border/40 shadow-soft" : "h-22 bg-background/95 backdrop-blur-sm border-b border-border/20"}`}>
        <div className="container mx-auto px-6 h-full flex items-center justify-between">
          {}
          <Link to="/" className="flex-shrink-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541635/img/strategyai_partners_logo.png" alt="StrategyAI Partners" className="h-7" />
          </Link>

          {}
          
        </div>
      </header>;
}